import { render, staticRenderFns } from "./SelfTest.vue?vue&type=template&id=250853b8&scoped=true"
import script from "./SelfTest.vue?vue&type=script&lang=js"
export * from "./SelfTest.vue?vue&type=script&lang=js"
import style0 from "./SelfTest.vue?vue&type=style&index=0&id=250853b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250853b8",
  null
  
)

export default component.exports